import { Base } from '@studiometa/js-toolkit';

export default class Newsletter extends Base
{
    /**
   * Component Configuration
   */
    static config = {
        name: 'Newsletter',
        refs: ['form', 'email', 'btn'],
    };

    mounted() {
        this.submit();
    }

    /**
     * Get action value
     * @returns {string} value.
    */
    get action() {
        return this.name.action;
    }

    submit() {
        this.$refs.btn.addEventListener( 'click', (e) => {
            e.preventDefault()
            // Hcaptcha est monter lors du clique sur un champs
            // c'est le comportement par defaut de shopify
            // Je force donc l'execution de hcaptcha pour récupérer le token
            hcaptcha.execute();
            observeDataHcaptchaResponse(this.$refs.form);
        })

        const observer = new MutationObserver((mutationsList) => {
          for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-hcaptcha-response') {
              const value = mutation.target.getAttribute('data-hcaptcha-response');
              if (value?.trim()) {
                const formData = new FormData(this.$refs.form);
                fetch('/contact', {
                    method: 'POST',
                    body: formData,
                })
                .then(response => response.text())
                .then(data => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(data, 'text/html');
                    const successElement = doc.getElementById('ContactFooter-success');
                    const newDiv = document.createElement("h3");
                    let newContent = '';

                    if (successElement) {
                        console.log('Contenu du message :', successElement.textContent.trim());
                        newDiv.classList.add('text-base', 'text-green-600', 'font-serif', 'font-bold', 'mt-2' , 'text-right');

                        newContent = document.createTextNode(successElement.textContent.trim());
                    } else {
                        newContent = document.createTextNode('Une erreur s\'est produite, veuillez ressayer plus tard.');
                        newDiv.classList.add('text-base', 'text-red-600', 'font-serif', 'font-bold', 'mt-2' , 'text-right');
                        console.log('Élément introuvable');
                    }

                    newDiv.appendChild(newContent);
                    const currentDiv = this.$el;
                    currentDiv.appendChild(newDiv);
                    this.$refs.email.value= '';
                })
                .catch(error => {
                  console.error('Error submitting form:', error);
                });
              }
            }
          }
        })

        function observeDataHcaptchaResponse(form) {
            const iframe = form.querySelector('iframe[data-hcaptcha-response]');
            if (iframe) {
                observer.observe(iframe, {
                    attributes: true,
                    attributeFilter: ['data-hcaptcha-response'],
                });
                
                // Valeur initiale éventuelle
                const initialValue = iframe.getAttribute('data-hcaptcha-response');
                if (initialValue) {
                    console.log('data-hcaptcha-response initial:', initialValue);
                }

            } else {
                // Attente du chargement dynamique de l’iframe
                setTimeout(() => observeDataHcaptchaResponse(form), 500);
            }
        }
    }
}

